<footer class="a03-disclaimer-footer" [ngClass]="'on-' + featureName.toLowerCase() + '-page'">
  <p class="legal-quote" aria-live="assertive" [innerHTML]="copy[featureDisclaimerCopy]"></p>
</footer>
